module.exports = __webpack_public_path__ + "img/NewsCenter_pic6.98105945.png";